import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class ReflectIcon extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="24" viewBox="0 0 20 24">
        <title>Reflect</title>
        <path fillRule="nonzero"
          fill={this.props.active ? '#ffffff' : '#979797'}
          d="M19 3h-3V1a1 1 0 0 0-2 0v2h-3V1a1 1 0 0 0-2
          0v2H6V1a1 1 0 0 0-2 0v2H1a1 1 0 0 0-1 1v19a1 1 0 0 0 1
          1h18a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm-4 12H5V9h10v6z" />
      </svg>
    );
  }
}

ReflectIcon.propTypes = {
  active: PropTypes.bool
};
